<template>
    <div>
        <div class="container-fluid">
            <div class="row g-0 h-100">
              <div class="col-lg-3">
                <div class="card card-body p-2">
                <button class="btn btn-lg btn-block btn-outline-primary mb-2" @click="$emit('customChange',{shell: 'Dashboard', dataset: ''})"><i class="fas fa-arrow-left"></i> Back to Dashboard</button>
                <hr>
                <h3>Geospatial Explorer</h3>
                <div class="not-form">
                  <!-- actual UI elements -->
                  <div class="d-grid gap-2">
                    <label>Locations:</label>
                    <select class="form-select">
                      <option :value="poi" v-for="(poi, index) in poilocations" :key="index">{{poi}}</option>
                    </select>
                    <button class="btn btn-outline-primary" @click="$emit('openModal', {view: 'AddGeospatialLocation', dt: ''})"><i class="fas fa-plus"></i> Add a new location</button>
                  </div>
                  <div class="d-grid gap-2 mt-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="points_of_interest">
                      <label class="form-check-label">
                        Points of interest
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="nearby_retail">
                      <label class="form-check-label">
                        Nearby retail
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="visits">
                      <label class="form-check-label">
                        Visits
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="traffic">
                      <label class="form-check-label">
                        Traffic
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="co_visits">
                      <label class="form-check-label">
                        Co-visits
                      </label>
                    </div>
                  </div>
                  <div class="d-grid gap-2">
                    <button class="btn btn-sm btn-primary">Download Mobile Advertising IDs</button>
                  </div>
                  <hr>
                  <h3>Map Testing:</h3>
                  <div class="form-group">
                  <label>Enter Location</label>
                    <input class="form-control input-lg" placeholder="Dunkin Donuts in Amesbury" v-model="blobRequest" />
                    <button class="btn btn-sm btn-info" @click="requestGeocode()">Look up location (Geocode)</button>
                  </div>
                  <hr>
                  <div class="form-group">
                    <label>Select Map Type</label>
                    <select class="form-select" v-model="maptype" @change="updateMapType">
                      <option value="freedraw" selected>Markers (Free Draw)</option>
                      <option value="polylines">Polylines</option>
                      <option value="heatmap">Heatmap</option>
                      <option value="markers">Markers (legacy)</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <!-- vue3-simple-typeahead
                    id="typeahead_id"
                    :minInputLength="1"
                    :items="['One','Two','Three']"
                    :itemProjection="itemProjectionFunction"
                    @selectItem="thetext"
                    @onInput="onInputEventHandler"
                    @onFocus="onFocusEventHandler"
                    @onBlur="onBlurEventHandler"
                    class="form-control input-lg"
                    >
                    </vue3-simple-typeahead -->
                  </div>

                  <div class="form-group">
                    <label>Enter Lat/Long Coordinates</label>
                    <textarea class="form-control" rows="5" v-model="thetext" />
                  </div>
                  
                    <div class="form-group d-none">
                      <label>Polyline Color</label>
                      {{currentCount}}
                      <select class="form-select" v-model="polylineColor">
                        <option value="black">Black</option>
                        <option value="red">Red</option>
                        <option value="green">Green</option>
                        <option value="blue">Blue</option>
                        <option value="purple">Purple</option>
                      </select>
                    </div>
                  
                  <div class="d-grid gap-2">
                    <button type="button" class="btn btn-sm btn-primary" @click="processLocationButton($event)">Update Map</button>
                  </div>
                  <div class="d-grid gap-2">
                    <hr>
                    <h5>Test endpoints</h5>
                    <button type="button" class="btn btn-sm btn-primary" @click="listPOIs($event)">List POIs</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="clearPolygon()">Clear Polygon</button>
                    <button type="submit" class="btn btn-sm btn-primary" @click="testRequest($event)">Test Endpoint</button>
                  </div>
                </div>
                </div>
              </div>
                <div class="col geospatial-map-container">
                  <div class="placed-map-card" v-if="isCloseButtonVisible">
                    <div class="card card-body">
                      <button class="btn-close" @click="closeElement()"></button>
                      <h3>{{mapBlobTitle}}</h3>
                      <span v-html="mapBlobResponse"></span>
                    </div>
                  </div>
                  <component 
                    ref="mapComponent"
                    v-bind:is="thiscomponent"
                    v-bind:locations="locations"
                    v-bind:polylines="polylines"
                    v-bind:maptype="maptype"
                    :key="componentKey"
                    @open-modal="openModal"
                    class="map-area"
                  />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SimpleTypeahead from 'vue3-simple-typeahead'
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'
import { ref, computed } from 'vue';
import axios from 'axios';
// import MarketResearchMapSat from "./MarketResearchMapSat.vue";
import MarketResearchMapSat from "./MarketOpenStreetMap.vue";
import MarketOpenStreetPolylineMap from "./MarketOpenStreetPolylineMap.vue";
import MarketOpenStreetHeatMap from "./MarketOpenStreetHeatMap.vue";
import MarketOpenStreetMapMarkers from "./MarketOpenStreetMapMarkers.vue";
export default {
  name: "TESTER Map",
  components: { MarketResearchMapSat, MarketOpenStreetHeatMap, MarketOpenStreetPolylineMap, MarketOpenStreetMapMarkers, SimpleTypeahead },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      }
    }
  },
  data() {
    return {
      componentKey: 0,
      thiscomponent: MarketOpenStreetMapMarkers,
      poilocations: ["Home", "Office", "Park"],
      locations: [],
      polylineColor: 'red',
      polylines: [],
      thetext: '',
      blobRequest: '',
      maptype: 'freedraw',
      isCloseButtonVisible: true,
      mapBlobTitle: 'Test response',
      mapBlobResponse: '<p>lorem ipsum.....</p>'
    };
  },
  methods: {
    closeElement() {
      this.isCloseButtonVisible = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    clearPolygon() {
      this.$refs.mapComponent.clearLastPolygon();
    },
    openModal(data) {
      console.log('openModal triggered in MapTester with data:', data.dt);
      this.$emit('openModal', {view: 'RetrieveMapBoundaries', dt: JSON.stringify(data.dt)});
    },
    parseLatLongString(inputString) {
        const lines = inputString.split('\n');
        const latLongArray = [];

        for (const line of lines) {
            const values = line.split(',');
            if (values.length === 2) {
            const lat = parseFloat(values[0].trim());
            const lng = parseFloat(values[1].trim());
            if (!isNaN(lat) && !isNaN(lng)) {
                latLongArray.push({ lat, lng });
            }
            }
        }
        return latLongArray;
    },
    processLocations(event) {
        // event.preventDefault();
        this.locations = [];
        // const text = ref('');
        this.locations = this.parseLatLongString(this.thetext);
        console.log('returned locations '+JSON.stringify(this.locations));
        this.forceRerender();
    },
    processLocationButton(event) {
        // event.preventDefault();
        this.locations = [];
        this.locations = this.parseLatLongString(this.thetext);
        this.forceRerender();
    },
    testRequest(event) {
      this.polylines = [];
      //axios.get('/pinpoint_test')
      axios.get('/pinpoint_test_authorized')
      .then(
			(response) => {
        console.log('test response: ', response);
        //var treatedresponse = response.data.replace(/['"]+/g, '');
        //console.log('treated response '+treatedresponse);
        //this.thetext = treatedresponse;
        //this.processLocations();
      }).catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    },
    pointsListRequest() {
      this.polylines = [];
      axios.get('/points_list')
      .then(
			(response) => {
        console.log(JSON.stringify(response.data));
        this.thetext = response.data;
        this.processLocations();
      }).catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    },
    requestGeocode() {
      // 500 error - seems to be set up correctly
      this.polylines = [];
      console.log('the request '+this.blobRequest);
      axios.get('/geocode',{ params: {addr: this.blobRequest} })
        .then(
        (response) => {
          console.log('geocode/address lookup response: ', response);
          //this.thetext = JSON.stringify(response.data);
          //this.processLocations();
        }).catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    addPOI(name, latitude, longitude, address, description, info) {
      // untested
      let formData = new FormData();
      formData.append('name', name);
      formData.append('latitude', latitude);
      formData.append('longitude', longitude);
      formData.append('address', address);
      formData.append('description', description);
      formData.append('info', info);
      axios.post('/add_poi', formData)
        .then(
        (response) => {
          console.log('Add POI response: '+JSON.stringify(response.data));
        }).catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    updatePOI(name, newname, latitude, longitude, address, description, info) {
      // untested
      let formData = new FormData();
      formData.append('name', name);
      formData.append('newname', newname);
      formData.append('latitude', latitude);
      formData.append('longitude', longitude);
      formData.append('address', address);
      formData.append('description', description);
      formData.append('info', info);
      axios.post('/update_poi', formData)
        .then(
        (response) => {
          console.log('Update POI response: '+JSON.stringify(response.data));
        }).catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    removePOI(name) {
        // untested
        let formData = new FormData();
        formData.append('name', name);
        axios.post('/remove_poi', formData)
          .then(
          (response) => {
            console.log('Remove POI response: '+JSON.stringify(response.data));
          }).catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
      },
      getPOI(name) {
        // untested
        let formData = new FormData();
        formData.append('name', name);
        axios.post('/get_poi', formData)
          .then(
          (response) => {
            console.log('Add POI response: '+JSON.stringify(response.data));
          }).catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
      },
      listPOIs(event) {
        // untested
        axios.post('/list_pois')
          .then(
          (response) => {
            console.log('List POIs response: '+JSON.stringify(response.data));
          }).catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
      },
     snapToRoad(request) {
      // untested
      axios.get('/snap_to_road',{ params: {request: request} })
        .then(
        (response) => {
          console.log('snap to road lookup response: '+JSON.stringify(response.data));
          this.thetext = JSON.stringify(response.data);
        }).catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    testMarkers() {
      this.polylines = [];
      this.heatdata = [];
      this.thetext = '29.76, -95.37\n30.27, -97.74\n32.72, -96.79\n32.80, -117.10\n33.45, -111.97\n34.05, -118.24\n36.17, -121.89\n37.77, -122.42\n38.63, -90.20\n39.20, -119.82\n39.95, -75.16\n40.71, -74.01\n40.85, -105.00\n41.38, -72.68\n41.88, -87.62\n42.33, -71.06\n44.98, -93.23\n45.52, -122.68\n47.61, -122.39';
      this.processLocations();
    },
    createPolylines() {
      var preplocations = this.parseLatLongString(this.thetext);
      var passedLocations =  this.convertLocationsToPolylines(preplocations);
      var polyline = [{id: 1, color: this.polylineColor, latLongs: passedLocations}];
      this.polylines = polyline;
      this.processLocations();
    },
    convertLocationsToPolylines(locations) {
      return locations.map((location, index) => ([location.lat, location.lng]));
    },
    updateMapType() {
      if(this.maptype == 'polylines') {
        this.thiscomponent = MarketOpenStreetPolylineMap;
        this.createPolylines();
      } else if (this.maptype == 'heatmap') {
        this.thiscomponent = MarketOpenStreetHeatMap;
      } else if (this.maptype == 'markers') {
        this.thiscomponent = MarketOpenStreetMapMarkers;
      } else if (this.maptype == 'freedraw') {
        this.thiscomponent = MarketResearchMapSat;
      }
    }
  },
  mounted() {
    console.log('map test loaded');
    this.$emit('toggleNav');
    this.updateMapType();
    if(this.locations.length === 0) {
      // this will load test markers to avoid default failure of no location data
      this.testMarkers();
    } else {
      this.processLocations();
    }
    
  }
};
</script>